export class ApplicationLog {

    constructor(applicationLog?: ApplicationLog) {

        if (applicationLog) {
            for (let prop in applicationLog) {
                if (applicationLog.hasOwnProperty(prop)) {
                    this[prop] = applicationLog[prop];
                }
            }
        }

    }

    summary: string;
    message: string;
    errorCode: string;
    // location: string;
    accountId: string;
    userId: string;
    stack: string;
    status: string;
    statusText: string;
    url: string;
    browserInfo: string;

}